const snow = () => {
  var embedimSnow = document.getElementById("embedim--snow");
  if (!embedimSnow) {
    function embRand(a, b) { return Math.floor(Math.random() * (b - a + 1)) + a }
    var embCSS = '.embedim-snow{position: absolute;width: 10px;height: 10px;background: white;border-radius: 50%;margin-top:-10px}';
    var embHTML = '';
    for (i = 1; i < 125; i++) {
      embHTML += '<i class="embedim-snow"></i>';
      var rndX = (embRand(0, 1000000) * 0.0001),
          rndO = embRand(-100000, 100000) * 0.0001,
          rndT = (embRand(3, 8) * 10).toFixed(2),
          rndS = (embRand(0, 10000) * 0.0001).toFixed(2);
      embCSS += '.embedim-snow:nth-child(' + i + '){' + 'opacity:' + (embRand(1, 4000) * 0.0001).toFixed(2) + ';' + 'transform:translate(' + rndX.toFixed(2) + 'vw,-10px) scale(' + rndS + ');' + 'animation:fall-' + i + ' ' + embRand(12, 36) + 's -' + embRand(0, 36) + 's linear infinite' + '}' + '@keyframes fall-' + i + '{' + rndT + '%{' + 'transform:translate(' + (rndX + rndO).toFixed(2) + 'vw,' + rndT + 'vh) scale(' + rndS + ')' + '}' + 'to{' + 'transform:translate(' + (rndX + (rndO / 2)).toFixed(2) + 'vw, 105vh) scale(' + rndS + ')' + '}' + '}'
  }
    embedimSnow = document.createElement('div');
    embedimSnow.id = 'embedim--snow';
    embedimSnow.innerHTML = '<style>#embedim--snow{position:fixed;left:0;top:0;bottom:0;width:100vw;height:100vh;overflow:hidden;z-index:30;pointer-events:none}' + embCSS + '</style>' + embHTML;
    document.body.appendChild(embedimSnow)
  }
}


const object = {
  "currentIndex": 0,
  "popup": document.querySelector('[data-popup]'),
  "popupBg": document.querySelector('[data-popup-bg]'),
  "popupCls": document.querySelector('[data-popup-close'),
  "popupPrev": document.querySelector('[data-popup-prev]'),
  "popupNext": document.querySelector('[data-popup-next]'),
  "popupTarget": document.querySelectorAll('[data-popup-target]'),
  "target": document.querySelectorAll('[data-target]'),
  "targetLength": document.querySelectorAll('[data-target]').length
}

const popupOpen = (html, index) => {
  document.querySelector('[data-popup]').classList.add('active')
  html.classList.add('active')
  object.popupTarget[index].classList.add('active')
  object.currentIndex = index
  // slider(object.popupTarget[index])
}

const popupPrev = () => {
  object.currentIndex--
  object.popupTarget.forEach(activeValue => {
    activeValue.classList.remove('active')
  })

  if(object.currentIndex < 0) {
    object.currentIndex = object.targetLength - 1
    object.popupTarget[object.currentIndex].classList.add('active')
  } else {
    object.popupTarget[object.currentIndex].classList.add('active')
  }
  // slider(object.popupTarget[object.currentIndex])
}

const popupNext = () => {
  object.currentIndex++
  object.popupTarget.forEach(activeValue => {
    activeValue.classList.remove('active')
  })

  if(object.targetLength - 1 < object.currentIndex) {
    object.currentIndex = 0
    object.popupTarget[object.currentIndex].classList.add('active')
  } else {
    object.popupTarget[object.currentIndex].classList.add('active')
  }
  slider(object.popupTarget[object.currentIndex])
}

const popupClose = () => {
  object.popup.classList.remove('active')
  object.popup.querySelectorAll('.active').forEach(activeValue => {
    activeValue.classList.remove('active')
  })
}

const slider = () => {
  const option = {
    cellAlign: "center",
    pageDots: false,
    wrapAround: true,
    fade: false,
    prevNextButtons: false,
    draggable: true,
    on: {
      ready: function() {
        this.off( 'uiChange', this.stopPlayer );
        this.off( 'pointerDown', this.stopPlayer );
      }
    }
  };

  const optionNav01 = {
    cellAlign: "left",
    pageDots: false,
    // wrapAround: true,
    asNavFor: ".p-popup__slider01",
    contain: true,
    pageDots: false,
    prevNextButtons: false,
    draggable: false,
  };
  const optionNav03 = {
    cellAlign: "left",
    pageDots: false,
    // wrapAround: true,
    asNavFor: ".p-popup__slider03",
    contain: true,
    pageDots: false,
    prevNextButtons: false,
    draggable: false,
  };

  let flkty01 = new Flickity(document.querySelector(`.p-popup__slider01`), option);
  let flktyNav01 = new Flickity(document.querySelector(`.p-popup__navs01`), optionNav01);
  let flkty03 = new Flickity(document.querySelector(`.p-popup__slider03`), option);
  let flktyNav03 = new Flickity(document.querySelector(`.p-popup__navs03`), optionNav03);
}

//read more
const readMore = (clsTxt, clsBtn) => {
  const targetTxt = document.querySelectorAll(`.${clsTxt}`)
  const openHeight = []
  const closeHeight = []
  Array.from(targetTxt).forEach(value => {
    openHeight.push(value.clientHeight)
    value.classList.add('is-hide')
    closeHeight.push(value.clientHeight)
  })
  const targetBtn = document.querySelectorAll(`.${clsBtn}`)

  Array.from(targetBtn).forEach((value, index) => {
    value.addEventListener('click', () => {

      if(value.classList.contains('is-show')) {
        document.querySelector('.p-gift').classList.remove('is-show')
        value.classList.remove('is-show')
        value.previousElementSibling.classList.remove('is-show')
        value.classList.add('is-hide')
        value.innerText = 'Read more' 
        value.previousElementSibling.classList.add('is-hide')
        value.previousElementSibling.style.height = `${closeHeight[index]}px`
      } else {
        document.querySelector('.p-gift').classList.add('is-show')
        value.classList.remove('is-hide')
        value.previousElementSibling.classList.remove('is-hide')
        value.classList.add('is-show')
        value.innerText = 'Close'
        value.previousElementSibling.classList.add('is-show')
        value.previousElementSibling.style.height = `${openHeight[index]}px`
      }
    })
  })
}

//wechat
const wechat = () => {
  const popup = document.querySelector('.p-sns__popup')

  document.addEventListener('click', (e) => {
    if(!e.target.closest('.p-sns__wechat')) {
      //ここに外側をクリックしたときの処理
      popup.classList.remove('show')
    } else {
      //ここに内側をクリックしたときの処理
      popup.classList.add('show')
    }
  })
}

// クーポンコードコピー
const copyFunc = () => {
  const target = document.querySelectorAll('[data-copy]')
  Array.from(target).forEach(value => {
    value.addEventListener('click', () => {
      navigator.clipboard.writeText(value.dataset.copy);
      value.nextElementSibling.classList.add('show')
      setTimeout(() => {
        value.nextElementSibling.classList.remove('show')
      }, 2000)
    })
  })
}

window.addEventListener('DOMContentLoaded', () => {
  snow()
  wechat()
})

window.addEventListener('load', () => {
  slider()
  readMore('js-accordion-txt', 'js-accordion-btn')
  copyFunc()
  Array.from(object.target).forEach((value, index) => {
    value.addEventListener('click', () => {
      popupOpen(value, index)
    })
  })
  object.popupBg.addEventListener('click', () => {
    popupClose()
  })
  object.popupCls.addEventListener('click', () => {
    popupClose()
  })
  object.popupPrev.addEventListener('click', () => {
    popupPrev()
  })
  object.popupNext.addEventListener('click', () => {
    popupNext()
  })
})